import React from "react";
import Box from "@mui/material/Box";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { checkEmail } from "../images";
import Text from "../text/Text";
import {
  checkEmailMsg,
  resend,
  verifyEmailHeader,
  verifyEmailSubHeader,
} from "../messages";
import { CustomLink } from "../link/Link";
import { resendVerification } from "../../redux/actions";

const EmailVerification = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const email = location?.state?.email;

  const handleResend = () => {
    dispatch(resendVerification({ email }));
  };
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      textAlign="center"
    >
      <img src={checkEmail} height={193} width={170} />
      <Text
        className="default-text mt-24"
        size={22}
        font="bold"
        sx={{ mt: 40 }}
      >
        {verifyEmailHeader}
      </Text>
      <Text className="grey-text mt-8" size={14}>
        {verifyEmailSubHeader}
      </Text>
      <Text className="default-text mt-24" size={14}>
        {checkEmailMsg}{" "}
        <CustomLink bold onClick={handleResend} size="small">
          {resend}
        </CustomLink>
      </Text>
    </Box>
  );
};

export default EmailVerification;
